<div class="content-top-box " dir="{{languageDir}}">
  <ul class="breadcrumb">
    <li class="breadcrumb-item" *ngFor="let breadcrumItem of breadcrumList">
      <a class="breadcrumb-link" [routerLink]="breadcrumItem.Url" [id]="breadcrumItem.id"
        (click)="DisplayRightmenu(breadcrumItem.id, breadcrumItem.Url)">{{lang.getTransalatedValue(breadcrumItem.text)}}</a>
    </li>
  </ul>
  <div class="title-row">
    <h1 class="main-title">{{langObj ? langObj?.CitiesAndCountries : ('CitiesAndCountries' | translate)}}</h1>
  </div>
  <div class="container">
    <mat-accordion>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header class="acc1" class="disable_ripple_acc1">
          <mat-panel-title>
            {{langObj ? langObj?.Countries : ('Countries' | translate)}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form [formGroup]="countryDataForm" style="margin-bottom: 10px;">
          <div class="content-top-row" style="margin-top: 30px;">
            <input formControlName="CId" [hidden]="true">
            <mat-form-field appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing">
              <input matInput formControlName="countryName" placeholder="{{langObj ? langObj?.CountryName : ('CountryName' | translate)}}">
              <mat-error class="error-msg" *ngIf="checkError('countryName', 'required')">{{langObj ? langObj?.CountryNameisrequired : ('CountryNameisrequired' | translate)}}
              </mat-error>
            </mat-form-field>
            <button *ngIf="saveUpdateCountry && IsWrite" [disabled]="!countryDataForm.valid" mat-mini-fab mat-button
              color="primary" type="submit" pTooltip="Submit" tooltipPosition="top" style="margin-left: 20px;"
              (click)="addNewCountry()">
             <mat-icon style="color: #fff">{{langObj ? langObj?.save : ('save' | translate)}}</mat-icon>
            </button>
            <button *ngIf="!saveUpdateCountry && IsWrite" [disabled]="!countryDataForm.valid" mat-mini-fab mat-button
              color="primary" type="submit" pTooltip="submit" tooltipPosition="top" style="margin-left: 20px;"
              (click)="updateCountry()">
             <mat-icon style="color: #fff">{{langObj ? langObj?.edit : ('edit' | translate)}}</mat-icon>
            </button>
            <button *ngIf="IsWrite" [disabled]="!countryDataForm.valid" (click)="reset()" mat-mini-fab mat-button
              color="primary" pTooltip="Reset" tooltipPosition="top" style="margin-left: 20px;">
             <mat-icon style="color: #fff">{{langObj ? langObj?.refresh : ('refresh' | translate)}}</mat-icon>
            </button>
          </div>
        </form>
        <ag-grid-angular style="width: 100%; height: 30vw;" class="ag-theme-alpine" [rowData]="countries"
          [columnDefs]="columnDefsCountry" [gridOptions]="gridOptions" (cellClicked)="cellClickedCountry($event)"
          (gridReady)="onGridReady($event)" [pagination]="true" [groupHideOpenParents]="true">
        </ag-grid-angular>
      </mat-expansion-panel>
      <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
        <mat-expansion-panel-header class="acc1" class="disable_ripple_acc1">
          <mat-panel-title>
            {{langObj ? langObj?.Cities : ('Cities' | translate)}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form [formGroup]="cityDataForm" style="margin-bottom: 10px;">
          <div class="content-top-row" style="margin-top: 30px;">
            <mat-form-field appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing">
              <input matInput formControlName="cityName" placeholder="City Name">
              <mat-error class="error-msg" *ngIf="checkErrorCity('cityName', 'required')">{{langObj ? langObj?.CityNameisrequired : ('CityNameisrequired' | translate)}}
              </mat-error>
            </mat-form-field>
            <input formControlName="Id" [hidden]="true">
            <mat-form-field appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing">
              <mat-select formControlName="countryName" placeholder="{{langObj ? langObj?.CountryName : ('CountryName' | translate)}}" name="countryName">
                <mat-select-filter [placeholder]="'Search'" [displayMember]="'name'" [array]="countries"
            (filteredReturn)="filteredModules = $event"></mat-select-filter>
                <mat-option *ngFor="let country of filteredModules" [value]="country.countryId">
                  {{ country.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <button *ngIf="saveUpdatecity && IsWrite" [disabled]="!cityDataForm.valid" mat-mini-fab mat-button
              color="primary" type="submit" pTooltip="submit" tooltipPosition="top" style="margin-left: 20px;"
              (click)="addNewCity()">
             <mat-icon style="color: #fff">{{langObj ? langObj?.save : ('save' | translate)}}</mat-icon>
            </button>

            <button *ngIf="!saveUpdatecity && IsWrite" [disabled]="!cityDataForm.valid" mat-mini-fab mat-button
              color="primary" type="submit" pTooltip="submit" tooltipPosition="top" style="margin-left: 20px;"
              (click)="updateCity()">
             <mat-icon style="color: #fff">{{langObj ? langObj?.edit : ('edit' | translate)}}</mat-icon>
            </button>
            <button [disabled]="!cityDataForm.valid && IsWrite" (click)="resetCity()" mat-mini-fab mat-button
              color="primary" pTooltip="Reset" tooltipPosition="top" style="margin-left: 20px;">
             <mat-icon style="color: #fff">{{langObj ? langObj?.refresh : ('refresh' | translate)}}</mat-icon>
            </button>
          </div>
        </form>
        <ag-grid-angular style="width: 100%; height: 30vw;" class="ag-theme-alpine" [rowData]="citiesRes"
          [columnDefs]="columnDefsCities" [gridOptions]="gridOptions" (cellClicked)="cellClickedCity($event)"
          (gridReady)="onGridReady($event)" [pagination]="true" [groupHideOpenParents]="true">
        </ag-grid-angular>
      </mat-expansion-panel>
    </mat-accordion>
  </div>